import type { PolarYesNoUndefined } from "@stryker/core/types/section";
import PolarQuestion from "@/components/job/PolarQuestion";

export type ProceedWithNextPolar = {
  do_you_wish_to_answer_more_questions: PolarYesNoUndefined;
};

type ProceedWithOtherChecksProps = {
  onHandleYesNo: (payload: { value: PolarYesNoUndefined; key: keyof ProceedWithNextPolar }) => void;
  polarQuestions: ProceedWithNextPolar;
};
export default function ProceedWithOtherChecks({ onHandleYesNo, polarQuestions }: ProceedWithOtherChecksProps) {
  return (
    <>
      <PolarQuestion
        shouldRender
        question="Do you wish to account for other design considerations? such as burial loads, axial loads, vacuum loads, pressure cycles, long term strains, or strength exclusion."
        onNoClick={() => {
          onHandleYesNo({ value: "no", key: "do_you_wish_to_answer_more_questions" });
        }}
        onYesClick={() => {
          onHandleYesNo({ value: "yes", key: "do_you_wish_to_answer_more_questions" });
        }}
        selection={polarQuestions.do_you_wish_to_answer_more_questions}
      />
    </>
  );
}
